module.exports = __webpack_public_path__ + "static/img/200292.0e1c6ba1.png";